module.exports = __webpack_public_path__ + "static/img/diamond.a812e9bd.svg";